import React from 'react';
import './Home.css'

const Home = () => {
    return (
        <div className='image mt-5'>
         
            <img className=' fluid' src='https://www.vlrtraining.in/wp-content/uploads/2019/07/Frontend-web-developer-online-training.jpg'/>
            
           
        </div>
    );
};

export default Home;